import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderArbeitsbereich';
import { Dayjs } from 'dayjs';

export type KalenderView = 'byMitarbeiter' | 'byArbeitsbereiche';

export type Abschnitt = { value: string; name: string };

export type KalenderFilterOptions = {
  berufe: string[];
  abschnitte: Abschnitt[];
  standorte: Standort[];
};

export const STATUS = ['geplant', 'aktiv', 'abgeschlossen'] as const;
export type Status = (typeof STATUS)[number];

export type UebersichtFilterOptions = {
  berufe: string[];
  abschnitte: Abschnitt[];
  status: Status[];
};

export interface RotationsplanFeatureProps {
  data: {
    uebersicht: {
      rotationsplaene: Rotationsplan[];
    };
    planung: {
      rotationsplaeneByArbeitsbereiche: KalenderArbeitsbereich[];
      rotationsplaene: Rotationsplan[];
    };
    abschnitte: Abschnitt[];
    berufe: Beruf[];
    standorte: Standort[];
  };
  ui: {
    year: string;
    kalender: {
      view: KalenderView;
      isScrolling: boolean;
      currentStartOfWeek: Dayjs;
      currentEndOfWeek: Dayjs;
      istSortierungAufsteigend: boolean;
      selectedFilterCount: number;
      filter: KalenderFilterOptions;
    };
    uebersicht: {
      filter: UebersichtFilterOptions;
    };
  };
}
